import React, { Component } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';

import { Row, Col } from 'reactstrap';

import * as actions from '../../actions/SearchActions';
import * as apiActions from '../../actions/ApiActions';

import SearchHeader from '../../components/SearchHeader/SearchHeader'
import Headline from '../../components/Headline/Headline'
import Section from '../../components/Section/Section'
import Button from "../../components/Button/Button";
import LogoCarousel from "../../components/LogoCarousel/LogoCarousel";
import PhotoSlider from "../../components/PhotoSlider/PhotoSlider";
import HeaderLink from '../../components/HeaderLink/HeaderLink';
import ContactForm from '../../components/ContactForm/ContactForm';

class HomeContainer extends Component {
  constructor(props) {
    super(props);

    this.handleSearchSubmit = this.handleSearchSubmit.bind(this);
  }

  componentDidMount() {
    const { updateFachgruppen } = this.props;

    updateFachgruppen();
  }

  handleSearchSubmit(searchQuery) {
    const { setRedirectedFromHome } = this.props;

    setRedirectedFromHome(true);
    this.props.history.push("/search/" + searchQuery.what + "/" + searchQuery.where + "/" + searchQuery.when);
  }

  render() {
    const { fachgruppen, searchQuery, sendContactMessage } = this.props;

    return (
      <div>
        <SearchHeader
          searchQuery={searchQuery}
          fachgruppen={fachgruppen}
          searchSubmit={this.handleSearchSubmit}
        />

        <Section triangle>
          <Row>
            <Col xs={'12'} lg={6} className={'margin-col'}>
              <Row style={{ alignItems: 'flex-end' }}>
                <Col xs={12} md={4}>
                  <img style={{bottom: '20px', width: '260px'}} className={'avatar'} src={'/img/avatars/Home-1.png'} />
                </Col>
                <Col xs={12} md={8}>
                  <Headline>Für Patienten</Headline>
                  <p>
                    Mit Quickdoctor können Sie in ganz einfach
                    und in kürzester Zeit einen Arzttermin finden,
                    der ihren Wunschkriterien entspricht.</p>
                  <Button light href={'/patient'}>Mehr erfahren</Button>
                </Col>
              </Row>
            </Col>
            <Col xs={'12'} lg={6}>
              <Row style={{ alignItems: 'flex-end' }}>
                <Col xs={12} md={4}>
                  <img style={{bottom: '20px', width: 'auto', height: '300px', left: '-130px'}} className={'avatar'} src={'/img/avatars/Home-2.png'} />
                </Col>
                <Col xs={12} md={8}>
                  <Headline>Für Ärzte</Headline>
                  <p>
                    Ihnen bietet Quickdoctor die Möglichkeit,
                    kurzfristig freigewordene Arzttermine schnell
                    und unkompliziert neu zu vermitteln.</p>
                  <Button light href={'/doktor'}>Mehr erfahren</Button>
                </Col>
              </Row>
            </Col>
          </Row>

        </Section>

        <Section greyGradient backgroundImage={'/img/team.png'}>
          <Row>
            <Col xs={'12'} lg={6} className={'margin-col'}>
              <Headline orange>Über uns</Headline>
              <p>Hinter Quickdoctor stehen wir: Max Schüler, Nina Sofie
                Krah und Lukas Liß. Wir studieren Zahnmedizin,
                Management und Informatik.<br />
                Mit Quickdoctor wollen wir einerseits Patienten in Not
                dabei helfen, schneller einen Arzttermin zu bekommen.<br />
                Andererseits möchten wir Ärzte dabei unterstützen,
                ihre Ausfallzeiten zu minimieren.</p>
              <Button href={'/team'}>Mehr erfahren</Button>
            </Col>
            <Col xs={'12'} lg={6}></Col>
          </Row>
        </Section>

        <Section>
          <Headline>Unsere Partner und Unterstützer</Headline>
          <LogoCarousel>
            <img src="/img/avatars/logos/logo1.png" />
            <img src="/img/avatars/logos/logo2.png" />
            <img src="/img/avatars/logos/logo3.png" />
            <img src="/img/avatars/logos/logo4.png" />
            <img src="/img/avatars/logos/logo5.png" />
            <img src="/img/avatars/logos/logo6.png" />
            <img src="/img/avatars/logos/logo7.png" />
            <img src="/img/avatars/logos/logo8.png" />
            <img src="/img/avatars/logos/logo9.png" />
          </LogoCarousel>
        </Section>

        <Section grey>
          <Row>
            <Col md={5} xs={12}>
              <Headline>Haben Sie noch Fragen?</Headline>
              <Headline small>Dann kommen Sie mit uns in Kontakt.</Headline>
              <ContactForm sendAction={(body) => sendContactMessage(body)} />
            </Col>

            <Col md={{ size: 5, offset: 1 }} xs={12}>
              <div style={{ display: 'flex', width: '100%', height: '100%', justifyContent: 'flex-end', flexDirection: 'column' }}>
                <Headline>Bekannt aus:</Headline>
                <img src={'/img/bekannt-aus.png'} />
              </div>
            </Col>
          </Row>

        </Section>

      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    fachgruppen: state.fachgruppen,
    searchQuery: state.searchQuery
  };
}

export default connect(mapStateToProps, {...actions, ...apiActions})(HomeContainer);



// WEBPACK FOOTER //
// ./src/container/public/HomeContainer.js